import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import compareAsc from 'date-fns/compare_asc'
import handleViewport from 'react-in-viewport'

import CommentsRecord from 'data/comments/record'
import { selectors as ActivityRegistrySelectors } from 'data/activityRegistry'
import { selectors as NotificationsSelectors } from 'data/notifications'
import { acknowledgeNotifications } from 'data/notifications/actions'
import { aknowledgeThreadActivity } from 'data/threads/actions'
import { filterAknowledgedOnCommentVisit } from 'data/notifications/aknowledgment'
import { ACTIVE } from 'data/activityRegistry/record'

import Comment from '../Comment'

class CommentWrapper extends Component {
  static propTypes = {
    comment: PropTypes.instanceOf(CommentsRecord).isRequired,
    highlight: PropTypes.string,
    goToThreadPanel: PropTypes.func,
    numberOfReplies: PropTypes.number,
  }
  state = {
    highlighted: false,
  }

  componentDidMount() {
    const { needsHighlight } = this.props

    if (needsHighlight) {
      this.setState({ highlighted: true })
      this.comment.scrollIntoView()
      this.highlightTimeout = setTimeout(() => {
        this.setState({ highlighted: false })
      }, 4000)
    }
  }

  componentWillUnmount = () => {
    clearTimeout(this.highlightTimeout)
  }

  render() {
    const {
      comment,
      noteId,
      showActivity,
      sameAuthorBefore,
      sameAuthorAfter,
      isResolved,
      highlight,
      isMainPanel,
      //for thread headers
      onReply,
      numberOfReplies,
      repliers,
      notificationCount,
    } = this.props

    return (
      <React.Fragment>
        <div ref={ref => (this.comment = ref)} />
        <Comment
          comment={comment}
          noteId={noteId}
          highlight={highlight}
          showActivity={showActivity}
          highlighted={this.state.highlighted}
          notificationCount={notificationCount}
          isResolved={isResolved}
          isMainPanel={isMainPanel}
          sameAuthorBefore={sameAuthorBefore}
          sameAuthorAfter={sameAuthorAfter}
          onReply={onReply}
          numberOfReplies={numberOfReplies}
          repliers={repliers}
        />
      </React.Fragment>
    )
  }
}

function getCommentIdFromLocation() {
  return new URLSearchParams(window.location.search).get('commentId')
}

const mapStateToProps = (state, { comment, isMainPanel }) => {
  const threadActivityStatus = ActivityRegistrySelectors.getActivityStatusFromThreadId(
    state,
    comment.threadId
  )
  const threadActivity = ActivityRegistrySelectors.getActivityFromThreadId(
    state,
    comment.threadId
  )
  const hasActivity = threadActivityStatus === ACTIVE
  const showActivity =
    (hasActivity && !threadActivity) || // The thread is active but user never aknowledged anything
    (hasActivity && // Or it is also active, but the user aknowledged the activity in the past so  we need to compare dates
      threadActivity &&
      compareAsc(threadActivity.aknowledgedAt, comment.createdAt) !== 1) ||
    (isMainPanel && hasActivity) // on main panel show the thread activity
  const notifications = isMainPanel
    ? NotificationsSelectors.getThreadNotifications(state)(comment.threadId)
    : NotificationsSelectors.getCommentNotifications(state)(comment.id)
  const notificationCount = notifications.size
  return {
    showActivity,
    needsHighlight: getCommentIdFromLocation() === comment.id,
    notificationCount,
  }
}

export default compose(
  connect(
    mapStateToProps,
    {
      aknowledgeThreadActivity,
      acknowledgeNotifications,
    },
    (
      stateProps,
      { acknowledgeNotifications, aknowledgeThreadActivity },
      ownProps
    ) => ({
      onEnterViewport: () => {
        if (stateProps.notificationCount) {
          setTimeout(() => {
            acknowledgeNotifications(notification =>
              filterAknowledgedOnCommentVisit({
                commentId: ownProps.comment.id,
              })(notification)
            )
          }, 4000)
        }
        if (stateProps.showActivity) {
          setTimeout(() => {
            aknowledgeThreadActivity(ownProps.noteId, ownProps.comment.threadId)
          }, 4000)
        }
      },
      ...stateProps,
      ...ownProps,
    })
  ),
  handleViewport
)(CommentWrapper)
